import { Box, Typography } from '@mui/material';

export default function PostSearchSelectionScreen() {
  return (
    <Box
      sx={{
        height: '100%',
        p: 5,
        gap: '1rem',
        flexGrow: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
      }}
    >
      <Typography variant="h2" component="h1" gutterBottom>
        Select a Result
      </Typography>
      <Typography variant="body1">
        Please select an item to view more details.
      </Typography>
    </Box>
  );
}
